import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import {
  INVENTARIOS_INGRESOMANUAL_EDITAR,
  INVENTARIOS_INGRESOMANUAL_NUEVO,
  INVENTARIOS_INGRESOMANUAL_LISTA,
  INVENTARIOS_INGRESOMASIVO_MAIN,
  INVENTARIOS_PROCESAMIENTO_MAIN,
  INVENTARIOS_OPERACIONES_MAIN,
  INVENTARIOS_REPORTES_MAIN,
  INVENTARIOS_REPORTES_X_PRODUCTO,
  INVENTARIOS_CONSULTA_PRODUCTO
} from 'constants/codigosTransacciones'

import * as IngresoManualPages from './ingresoManual'
import IngresoMasivoPage from './ingresoMasivo'
import ProcesamientoPage from './procesamiento'
import ReportesPage from './reportes'
import OperacionesPage from './operaciones'
import ReportePorProductoPage from './reportes/reportexProducto'
import ConsultarProducto from './reportes/consultaProducto'

import * as Formatos from './reportes/formatos'

export default function InventariosFisicosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${INVENTARIOS_INGRESOMANUAL_EDITAR}/:idTempInventario`} component={IngresoManualPages.EditarPage} />
        <Route path={`/${INVENTARIOS_INGRESOMANUAL_NUEVO}`} component={IngresoManualPages.NuevoPage} />
        <Route path={`/${INVENTARIOS_INGRESOMANUAL_LISTA}`} component={IngresoManualPages.ListaPage} />
        <Route path={`/${INVENTARIOS_INGRESOMASIVO_MAIN}`} component={IngresoMasivoPage} />
        <Route path={`/${INVENTARIOS_PROCESAMIENTO_MAIN}`} component={ProcesamientoPage} />
        <Route path={`/${INVENTARIOS_OPERACIONES_MAIN}`} component={OperacionesPage} />

        {/* Reportes individuales */}
        <Route path={`/${INVENTARIOS_REPORTES_MAIN}/formato-12-1`} component={Formatos.Formato12p1} />
        <Route path={`/${INVENTARIOS_REPORTES_MAIN}/formato-13-1`} component={Formatos.Formato13p1} />
        <Route path={`/${INVENTARIOS_REPORTES_MAIN}/formato-3-7`} component={Formatos.Formato3p7} />
<Route path={`/${INVENTARIOS_REPORTES_MAIN}/tipo-operacion`} component={Formatos.ReportexTipoOperacion} />
        <Route path={`/${INVENTARIOS_REPORTES_MAIN}/cruce-compras`} component={Formatos.FormatoCruceComprasKardex} />
        <Route path={`/${INVENTARIOS_REPORTES_MAIN}/transferencias`} component={Formatos.ReporteEntradasSalidas} />
        <Route path={`/${INVENTARIOS_REPORTES_MAIN}/stock-general`} component={Formatos.ReporteGeneralStock} />

        {/* Otros reportes (CruceVentas, Utilidad) */}
        <Route exact path={`/${INVENTARIOS_REPORTES_MAIN}`} component={ReportesPage} />

        <Route path={`/${INVENTARIOS_REPORTES_X_PRODUCTO}/:idProducto`} component={ReportePorProductoPage} />
        <Route path={`/${INVENTARIOS_CONSULTA_PRODUCTO}/:idProducto`} component={ConsultarProducto} />
      </Switch>
    </Suspense>
  )
}
